import Nav from "react-bootstrap/Nav";
import { Link } from 'react-router-dom';
import Navbar from "react-bootstrap/Navbar";

const HeaderLoggedOutDesktop = () => { 

    return (
        <>
        <div className="d-lg-block d-none">            
                <Navbar fixed="top" collapseOnSelect expand="lg" className="navbar-custom" style={{
                        height:"56px", 
                        background: 'rgba(255, 255, 255, 0.98)',
                        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
                        backdropFilter: 'blur(10px)',
                        paddingRight:"5px"
                    }}>
                    
                    <Navbar.Brand>
                        <a href="/" style={{color: "#2d3748",textDecoration:"none", marginLeft:"10px", fontWeight:"500"}}>
                            Elliot Koss
                        </a>
                    </Navbar.Brand>

                    <Nav className="ms-auto">
                        <Link to="/ai-notes" 
                            className="d-inline-flex align-items-center p-2"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1.1rem", 
                                fontWeight: "400", 
                                lineHeight: "1.5", 
                                borderRadius: "0.25rem",
                                marginRight: "1rem"
                            }}
                        >
                            AI Notes
                        </Link>
                        <Link to="/contact" 
                            className="d-inline-flex align-items-center p-2"
                            style={{
                                color: "#4a5568", 
                                textDecoration: "none",
                                fontSize: "1.1rem", 
                                fontWeight: "400", 
                                lineHeight: "1.5", 
                                borderRadius: "0.25rem",
                            }}
                        >
                            Contact
                        </Link>
                    </Nav>
                    
                </Navbar>
        </div>
        </>
    )
}

export default HeaderLoggedOutDesktop;